import { atom, useRecoilValue, useSetRecoilState } from "recoil";

const orderDeliveryListAtom = atom({ key: "orderDeliveryListAtom", default: { task_list: [] } });

export const SetOrderDeliveryList = () => useSetRecoilState(orderDeliveryListAtom);
export const GetOrderDeliveryList = () => useRecoilValue(orderDeliveryListAtom);
